import React, { useState, useEffect, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { ApplicationShared } from 'core'
import { NotFoundPageNumber, NotFoundPageWrapper, NotFoundPageTitle, NotFoundPageButtons, BackButton, MainButton, NotFoundPageWrapperOuter } from './styles'
import { getLastApp, getLastPath } from 'routeHistory'

export const NotFoundPage: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const [showBack, setShowBack] = useState(false)

  useEffect(() => {
    let canGoBack = false;
    const currentApp = ApplicationShared.application;
  
    if (getLastPath() && getLastApp() === currentApp) {
      canGoBack = true;
    }
  
    if (!canGoBack && document.referrer) {
      try {
        const sameOrigin = new URL(document.referrer).origin === window.location.origin;
        const sameApp    = getLastApp() === currentApp;
        console.log('📋 sameOrigin =', sameOrigin, 'sameApp =', sameApp);
        if (sameOrigin && sameApp) {
          canGoBack = true;
        }
      } catch (e) {
        console.warn(e);
      }
    }

    setShowBack(canGoBack);
  }, []);

  const handleGoBack = useCallback(() => {
    if (getLastPath() && getLastApp() === ApplicationShared.application) {
      history.replace(getLastPath())
    } else {
      history.goBack()
    }
  }, [history])

  const handleGoHome = useCallback(() => {
    history.replace('/')
  }, [history])

  return (
    <NotFoundPageWrapperOuter>
      <NotFoundPageWrapper>
        <NotFoundPageNumber>404</NotFoundPageNumber>
        <NotFoundPageTitle>{t('errorpage.title')}</NotFoundPageTitle>
      </NotFoundPageWrapper>
      <NotFoundPageButtons>
        {showBack && (
          <BackButton onClick={handleGoBack}>
            {t('errorpage.back')}
          </BackButton>
        )}
        <MainButton onClick={handleGoHome}>
          {t('errorpage.main')}
        </MainButton>
      </NotFoundPageButtons>
    </NotFoundPageWrapperOuter>
  )
}

export default NotFoundPage
import React, { useState, useEffect, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { ApplicationShared } from 'core'
import { NotFoundPageNumber, NotFoundPageWrapper, NotFoundPageTitle, NotFoundPageButtons, BackButton, MainButton, NotFoundPageWrapperOuter } from './styles'
import { getLastApp, getLastPath } from 'routeHistory'

export const NotFoundPage: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const [showBack, setShowBack] = useState(false)

  useEffect(() => {
    let canGoBack = false;
    const currentApp = ApplicationShared.application;
  
    if (getLastPath() && getLastApp() === currentApp) {
      canGoBack = true;
    }
  
    if (!canGoBack && document.referrer) {
      try {
        const sameOrigin = new URL(document.referrer).origin === window.location.origin;
        const sameApp    = getLastApp() === currentApp;
        console.log('📋 sameOrigin =', sameOrigin, 'sameApp =', sameApp);
        if (sameOrigin && sameApp) {
          canGoBack = true;
        }
      } catch (e) {
        console.warn(e);
      }
    }

    setShowBack(canGoBack);
  }, []);

  const handleGoBack = useCallback(() => {
    if (getLastPath() && getLastApp() === ApplicationShared.application) {
      history.replace(getLastPath())
    } else {
      history.goBack()
    }
  }, [history])

  const handleGoHome = useCallback(() => {
    history.replace('/')
  }, [history])

  return (
    <NotFoundPageWrapperOuter>
      <NotFoundPageWrapper>
        <NotFoundPageNumber>404</NotFoundPageNumber>
        <NotFoundPageTitle>{t('errorpage.title')}</NotFoundPageTitle>
      </NotFoundPageWrapper>
      <NotFoundPageButtons>
        {showBack && (
          <BackButton onClick={handleGoBack}>
            {t('errorpage.back')}
          </BackButton>
        )}
        <MainButton onClick={handleGoHome}>
          {t('errorpage.main')}
        </MainButton>
      </NotFoundPageButtons>
    </NotFoundPageWrapperOuter>
  )
}

export default NotFoundPage
